/**
 * Global loader
 */
import { MouseEvent } from 'react';
import { dispatch } from 'store';

import { GLOBAL_LOADER_SET } from '../action-types/global-loader.action-types';
import { GlobalLoaderType } from '../reducers/global-loader.reducer';

// eslint-disable-next-line import/prefer-default-export,max-len
export const setGlobalLoader = (showGlobalLoader: boolean, mouseEvent?: MouseEvent, globalLoaderType?: GlobalLoaderType) => {
  // Do not dispatch on cmd + click event.
  if (mouseEvent?.metaKey || mouseEvent?.ctrlKey) {
    return;
  }

  dispatch({ type: GLOBAL_LOADER_SET, showGlobalLoader, globalLoaderType });
};
